<template>
  <div class="header">
    <router-view name="header"/>
  </div>
  <div class="app-main" id="main">
    <div class="side">
      <router-view name="side"/>
    </div>
    <div class="content">
      <router-view/>
      <div id="app-drawer"/>
    </div>

    <a-float-button-group>
      <a-float-button @click="app.active.theme.dark = !app.active.theme.dark"
                      :tooltip="app.active.theme.dark ? '亮色' : '暗色'">
        <template #icon>
          <bulb-outlined/>
        </template>
      </a-float-button>
      <a-float-button @click="fullscreen.toggleFullscreen()"
                      :tooltip="fullscreen.isFullscreen.value ? '退出全屏' : '全屏'">
        <template #icon>
          <fullscreen-exit-outlined v-if="fullscreen.isFullscreen.value"/>
          <fullscreen-outlined v-else/>
        </template>
      </a-float-button>
    </a-float-button-group>
  </div>
</template>

<script setup lang="ts">

import {onUpdated} from "vue";
import {BulbOutlined, FullscreenExitOutlined, FullscreenOutlined} from "@ant-design/icons-vue";
import app from "@/model/app";
import fullscreen from "@/lib/fullscreen";

onUpdated(() => {
  document.getElementsByClassName('content').item(0)?.scrollTo(0, 0)
})
</script>

<style scoped lang="sass">
.header
  max-height: 70px
  background: var(--ant-color-bg-base)
  //box-shadow: 0 5px 20px 0 var(--ant-color-text-quaternary)
  box-shadow: var(--shadow-layout)
  display: flex
  justify-content: space-between
  align-items: center
  z-index: 3

.app-main
  flex: 1
  display: flex
  flex-flow: row nowrap
  height: calc(100vh - 70px)

  :where(.css-dev-only-do-not-override-1p3hq3p).ant-drawer
    position: absolute

  > .side
    background: var(--ant-color-bg-base)
    //box-shadow: 8px 0 27px 0 var(--ant-color-text-quaternary)
    box-shadow: var(--shadow-layout)
    z-index: 2
    position: relative
    display: flex
    flex-direction: column
    transition: all .3s
    overflow: visible

    &::-webkit-scrollbar
      display: none

  > .content
    flex: 1
    overflow-y: auto
    overflow-x: hidden
    position: relative
</style>